export default __webpack_public_path__ + "static/media/arrow-down.844fa38f.svg";